import { t } from '../../i18n.es.js';
import React from 'react';
import { styled, Tag } from '@teko/ui';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const ProductName = (_a) => {
  var _b = _a, {
    name,
    status,
    needManageStock,
    totalAvailableByStocks = 0,
    isFlashSelling = false,
    tag
  } = _b, props = __objRest(_b, [
    "name",
    "status",
    "needManageStock",
    "totalAvailableByStocks",
    "isFlashSelling",
    "tag"
  ]);
  const NameTag = StyledProductName.withComponent(tag ? tag : "div");
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(NameTag, __spreadProps(__spreadValues({}, props), {
    maxLines: totalAvailableByStocks > 0 && totalAvailableByStocks < 5 ? 2 : 3
  }), status && /* @__PURE__ */ React.createElement(StyledTag, __spreadValues({}, __spreadProps(__spreadValues({}, status), { children: status.value, variant: "primary" }))), /* @__PURE__ */ React.createElement(StyledH3, null, name)), !isFlashSelling && needManageStock && totalAvailableByStocks > 0 && totalAvailableByStocks < 5 && /* @__PURE__ */ React.createElement(RemainingProduct, null, t("Ch\u1EC9 c\xF2n {{totalAvailableByStocks}} s\u1EA3n ph\u1EA9m", {
    totalAvailableByStocks
  })));
};
const StyledProductName = styled.div(({ maxLines = 3 }) => `
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: left;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: ${maxLines};
  font-size: 13px;
`);
const StyledTag = styled(Tag)(({ color }) => `
  margin-right: 0.2rem;
  background-color: ${color};
  padding: 1px 0.4rem;
  font-size: 13px;
  font-weight: 400;
  padding: 2px 8px;
  border-radius: 4px;
`);
const RemainingProduct = styled.div`
  color: #d9852b;
  font-size: 0.75rem;
  margin-top: 2px;
  margin-bottom: 8px;
  line-height: 1rem;
`;
const StyledH3 = styled.h3`
  font-size: 0.75rem;
  font-weight: 400;
  line-height: 1rem;
  display: inline;
`;

export { ProductName };
